<template>
  <div class="tree-menu" :class="[depth === 2 ? 'header01' : '']">
    <div
      class="label-wrapper"
      :class="{
        'label-wrapper_1': type === '1' && !showChildren,
        'label-wrapper_2': type === '1' && showChildren,
      }"
      @click="toggleChildren"
    >
      <!-- <div :style="indent" v-if="type=='4'" class="header_div">
				<div class="title_div">
					<img v-if="!showChildren" src="../../static/talks/t_worker.png" class="icon_img" />
					<img v-else src="../../static/talks/t_workered.png" class="icon_img" />
					<div :class="{'title_text':!showChildren, 'titled_text':showChildren}">
						{{label}}（{{$store.state.colleagueNum}}）
						<img v-if="label=='我的同事' && !this.$store.state.hideOlc" src="../../static/talks/t_eyesop.png" @click.stop="changeEyes" style="margin-left: 5px;height: 14px;">
						<img v-if="label=='我的同事'  && this.$store.state.hideOlc" src="../../static/talks/t_eyesclose.png" @click.stop="changeEyes" style="margin-left: 5px;height: 14px;">
					</div>
				</div>
				<div v-if="nodes" class="arrow_div" ref="toggleicon()">
					<img v-if="!showChildren" src="../../static/talks/t_down.png"
						style="width: 0.75rem;height: 0.5rem;" />
					<img v-else src="../../static/talks/t_downed.png" style="width: 0.75rem;height: 0.5rem;" />
				</div>
			</div> -->
      <div
        :style="{
          'padding-left':
            depth == '1' ? depth * 0.25 + 'rem' : depth * 8 + 'px',
        }"
        v-if="type == '1'"
        class="dep_div"
        :class="labelClasses"
      >
        <div class="deparrow_div" ref="toggleicon">
          <img
            v-if="!showChildren"
            src="../../static/talks/icon_fullscreen2.png"
            style="width: 1.25rem; height: 1.25rem"
          />
          <img
            v-else
            src="../../static/talks/icon_fullscreen4.png"
            style="width: 1.25rem; height: 1.25rem"
          />
          <!-- <img v-if="!showChildren" src="../../static/talks/t_workdown.png"
						style="width:0.75rem;height: 0.75rem;" />
					<img v-else src="../../static/talks/t_workdowned.png" style="width:0.75rem;height: 0.75rem;" /> -->
        </div>
        <div
          :class="{ depname_div: !showChildren, depnamed_div: showChildren }"
        >
          {{ label }}
          <img
            v-show="
              depth == 1 && !this.$store.state.hideOlc && itemObj.downFlag
            "
            src="../../static/talks/t_eyesop.png"
            @click.stop="changeEyes"
            style="margin-left: 5px; height: 0.875rem"
          />
          <img
            v-show="depth == 1 && this.$store.state.hideOlc && itemObj.downFlag"
            src="../../static/talks/t_eyesclose.png"
            @click.stop="changeEyes"
            style="margin-left: 5px; height: 0.875rem"
          />
        </div>
      </div>

      <!-- (itemObj.talkedSessionCount && itemObj.talkedSessionCount > 0) || -->
      <!-- {{
        itemObj &&
        itemObj.talkedSessionCount !== null &&
        itemObj.talkedSessionCount > 0
      }} -->
      <div
        v-if="
          (type == '2' &&
            this.$store.state.hideOlc &&
            itemObj.userStatus != '-1') ||
          (itemObj &&
            itemObj.talkedSessionCount !== null &&
            itemObj.talkedSessionCount > 0) ||
          (type == '2' && !this.$store.state.hideOlc) ||
          (type == '2' && itemObj.onduty)
        "
        class="customer_div"
        :style="{
          'background-color':
            $store.state.currentColleageInfo &&
            $store.state.currentColleageInfo.id === itemObj.id
              ? '#e7f0ff '
              : '',
        }"
        @click="changeBg(itemObj)"
      >
        <div class="right_div2">
          <div style="position: relative">
            <img
              @error="handleImageError"
              :src="itemObj.portrait"
              :class="[
                itemObj.userStatus == '-1'
                  ? 'common-avatar common-avatar-offline'
                  : 'common-avatar',
              ]"
            />
            <span
              class="colleageDiaCount"
              v-if="
                itemObj.talkedSessionCount && itemObj.talkedSessionCount !== 0
              "
              ><span>{{
                itemObj.talkedSessionCount > 100
                  ? "99+"
                  : itemObj.talkedSessionCount
              }}</span></span
            >
          </div>
          <div class="line21_div">
            <!-- 在线状态：1-在线 2-忙碌 0-离开  -1-离线 -->
            <!-- <div class="state_div">
              <div
                class="leave_div leavebg_color"
                v-if="itemObj.userStatus == '0'"
              ></div>
              <div
                class="on_div onlinebg_color"
                v-else-if="itemObj.userStatus == '1'"
              ></div>
              <div
                class="busy_div busybg_color"
                v-else-if="itemObj.userStatus == '2'"
              ></div>
              <div
                class="off_div offbg_color"
                v-else-if="itemObj.userStatus == '-1'"
              ></div>
            </div> -->
            <div class="state_text">
              <div>
                <span> {{ label }}</span>
                <!-- <img
                  v-if="itemObj.phoneStatus === 0"
                  src="../../static/mydia/mobile.png"
                  alt=""
                />
                <img
                  v-if="itemObj.phoneStatus === 1"
                  src="../../static/mydia/mobileH.png"
                  alt=""
                /> -->
              </div>
              <span style="color: #de4f4f" v-if="itemObj.userStatus == '0'"
                >[离开]{{ itemObj.csTimeLength }}</span
              >
              <span style="color: #70b603" v-if="itemObj.userStatus == '1'"
                >[在线]{{ itemObj.csTimeLength }}</span
              >
              <span style="color: #f59a23" v-if="itemObj.userStatus == '2'"
                >[忙碌]{{ itemObj.csTimeLength }}</span
              >
              <span style="color: #999999" v-if="itemObj.userStatus == '-1'"
                >[离线]</span
              >
            </div>
          </div>
        </div>
      </div>
      <!-- <div
        v-if="type == '3'"
        @click.stop="clickSession(itemObj, supernodes)"
        class="client_div"
      >
        <workItem :item="itemObj"></workItem>
      </div> -->
    </div>

    <div v-show="showChildren">
      <div
        v-if="itemObj && itemObj.type == 1 && itemObj.nodes === null"
        class="noColleage"
      >
        当前部门没有其他同事
      </div>
      <!-- <div v-if="itemObj && !itemObj.nodes" class="noColleage">
        当前部门没有其他同事
      </div> -->
      <collegeTree
        v-for="(node, index) in nodes"
        :nodes="node.nodes"
        :label="node.name"
        :key="index"
        :depth="depth + 1"
        :itemObj="node"
        :type="node.type"
        :supernodes="nodes"
      ></collegeTree>
    </div>
  </div>
</template>

<script>
// import workItem from "./workItem.vue";

export default {
  name: "collegeTree",

  props: ["label", "nodes", "depth", "itemObj", "type", "supernodes"], //1-部门, 2-人员 3-访客 4-根节点(我的同事)

  // components: {
  //   workItem,
  // },

  data() {
    return {
      showChildren: true,
      // hideOlc: false,
      eyesOpenSrc: "../../static/talks/t_eyesop.png",
      eyesCloseSrc: "../../static/talks/t_eyesclose.png",
      // nowNodeList:this.$store.state.authority.selectedNodeList,
    };
  },
  // computed:{

  // },
  mounted() {
    // 计算部门高度
    console.log("header01----:", this.depth, typeof this.depth);
    if (this.depth === 1) {
      let header01 = document.querySelector(".header01");
      if (header01) {
        var mydia_div_header = document.querySelector(".mydia_div_header");
        console.log("header01----:", header01, header01.offsetTop);
        console.log(
          "window.innerHeigt, header01.offsetTop:",
          window.innerHeight,
          header01.offsetTop,
          header01.scrollTop,
          header01.offsetParent
        );
        header01.parentElement.classList.add("header01Parent");
        header01.parentElement.style.maxHeight =
          window.innerHeight -
          header01.offsetTop -
          mydia_div_header.offsetHeight +
          "px";
        console.log(
          " header01.parentElement.style.maxHeight----:",
          header01.parentElement.style.maxHeight
        );
      }
    }
  },
  created() {
    // if(this.hideOlc){
    // 	if(this.type == '2'){
    // 		this.showNode = true
    // 	}
    // }else if(!this.hideOlc){
    // 	if(this.itemObj.userStatus !='-1'){
    // 		this.showNode = false
    // 	}else{
    // 		this.showNode = true
    // 	}
    // }else{
    // 	this.showNode = false
    // }
    // console.log("this.showNode",this.showNode)
  },

  computed: {
    // collegeTreeData() {
    //   console.log(
    //     "collegeTree computed collegeTreeData = ",
    //     this.$store.state.college.collegeTreeData
    //   );
    //   return this.$store.state.college.collegeTreeData;
    // },
    iconClasses() {
      console.log("collegeTree iconClasses showChildren = ", this.showChildren);
      return {
        "fa-plus-square-o": !this.showChildren,
        "fa-minus-square-o": this.showChildren,
      };
    },
    labelClasses() {
      return {
        "has-children": this.nodes,
      };
    },
  },

  methods: {

    handleImageError(event) {
      // 图片加载失败时替换为占位图
      event.target.src = "https://css-resource-prod.oss-cn-beijing.aliyuncs.com/image/default/def_portrait.png";
      // 防止无限循环（如果占位图也加载失败）
      event.target.removeEventListener('error', this.handleImageError);
    },
    changeBg(obj) {
      if (this.$store.state.colleageAngle) {
        if (this.$store.state.currentColleageInfo.id !== obj.id) {
          this.$store.commit("changeBg", obj);
          // this.$store.state.selectedClient.isChecked = false;
          // this.$store.state.college.nowSelectClient.isChecked = false;
          console.log(
            "---------------============：-",
            this.$store.state.selectedClient,
            this.$store.state.college.nowSelectClient
          );
          // this.$store.state.selectedClient = null;
          // this.$store.state.college.nowSelectClient = null;
        }
      } else {
        this.$store.commit("changeBg", obj);
        // this.$store.state.college.nowSelectClient.isChecked = false;
        console.log(
          "---------------============：-",
          this.$store.state.selectedClient,
          this.$store.state.college.nowSelectClient
        );
        // this.$store.state.selectedClient = null;
        // this.$store.state.college.nowSelectClient = null;
        this.$store.commit("changeColleageAngle", true);
      }
    },
    toggleChildren() {
      console.log("collegeTree toggleChildren");
      this.showChildren = !this.showChildren;
      console.log("this.showChildren:", this.showChildren);
    },

    clickSession(session, superNode) {
      console.log("collegeTree clickSession session = ", session);
      console.log("collegeTree clickSession superNodes = ", superNode);
      this.$store.state.college.selectedNodeList = null;
      this.$store.state.college.selectedNodeList = superNode;

      // for(var i = 0; i < superNode.length; i++) {
      // 	var node = superNode[i]

      // 	if (node.cid === session.cid && node.sid === session.sid) {
      // 		node.isChecked = true
      // 	} else {
      // 		node.isChecked = false
      // 	}
      // }
    },
    async changeEyes() {
      console.log("changeEyes：展示或者隐藏");
      let status = this.$store.state.hideOlc ? 0 : 1;
      var api = "/manager/user/hd/olc";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          status: status,
        },
      });
      if (response.resultCode == 10000) {
        this.$store.commit("changeHideOlc", !this.$store.state.hideOlc);
      } else {
        this.$message.error(response.desc);
      }
    },
  },
};
</script>

<style scoped="scoped" lang="scss">
.label-wrapper,
.label-wrapper_1,
.label-wrapper_2 {
  /* background: cyan; */
  display: flex;
}

.label-wrapper_1 {
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.label-wrapper_2 {
  border-bottom: 1px solid #5a9cf8;
}

.header_div {
  height: 2.8125rem;
  display: flex;
  width: 100%;
}

.icon_img {
  width: 1rem;
  height: 1.125rem;
  margin-left: 1rem;
  margin-right: 0.5rem;
}

.title_div {
  width: 90%;
  height: 100%;
  display: flex;
  align-items: center;
}

.title_text,
.titled_text {
  @include change_size($font_size_normal);
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #444444;
  display: flex;
  align-items: center;
}

.titled_text {
  color: #5a9cf8;
}

.arrow_div {
  width: 10%;
  height: 100%;
  color: #666;
  transition: all 0.8s;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dep_div {
  width: 100%;
  height: 45px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
  margin-top: 2px;
  background-color: #f1f1f1;
}

.deparrow_div {
  //   width: 0.75rem;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 0.375rem;
}

.depname_div,
.depnamed_div,
.cusname_div,
.cusnamed_div {
  @include change_size($font_size_normal);
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 600;
  color: #444444;
}

.depname_div,
.depnamed_div {
  width: 90%;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  // background-color: orange;
}

.customer_div {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0 6px;
  background-color: #fff;
  box-sizing: border-box;
  cursor: pointer;
  &:hover {
    // font-size: 60px;
    background-color: #e7f0ff !important;
  }
  // background-color: yellow;
}
.common-avatar {
  border-radius: 0.375rem;
  width: 2.75rem;
  height: 2.75rem;
  vertical-align: middle;
  position: relative;
}
.common-avatar-offline {
  -webkit-filter: grayscale(1); /* Webkit */
  filter: gray; /* IE6-9 */
  filter: grayscale(1); /* W3C */
}

.cusname_div,
.cusnamed_div {
  width: 9.375rem;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-left: 0.25rem;
}

// .depnamed_div,
// .cusnamed_div {
//   color: #5a9cf8;
// }

.state_div {
  width: 0.75rem;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.leave_div,
.on_div,
.busy_div,
.off_div {
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  // background-color: cyan;
}

.client_div {
  cursor: pointer;
  width: 100%;
  height: 100%;
}

.state_text {
  @include change_size($font_size_normal);
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  // width: 9.375rem;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  //   align-items: center;

  // background-color: gold;
  text-overflow: ellipsis;
  overflow: hidden;
  //   white-space: nowrap;
  & > div {
    span:nth-of-type(1) {
      color: #444;
    }
    img {
      width: 0.625rem;
      height: 0.875rem;
      vertical-align: middle;
      margin-left: 0.25rem;
    }
  }
}

.right_div2 {
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  // background-color: #e2e8f0;
}

.line21_div {
  display: flex;
  align-items: center;
  // background-color: cyan;
  //   height: 2.5rem;
  width: 100%;
  box-sizing: border-box;
  border-bottom: 1px dashed #ddd;
  margin-left: 0.25rem;
  padding: 0.625rem 0;
}

.line22_div {
  @include change_tip_size($tip_size_normal);
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: bold;
  // background-color: orange;
  // padding-left: 1rem;
  // margin-bottom: 0.3125rem;
}
.colleageDiaCount {
  @include change_tip_size($tip_size_normal);
  position: absolute;
  text-align: center;
  background-color: #1577d2;
  right: 0;
  transform: translateX(10%);
  color: #fff;
  top: 0;
  white-space: nowrap;
  border-radius: 50%;
  min-width: 20px;
  min-height: 20px;
  padding: 2px;
  line-height: 1;
  box-sizing: content-box;
  &:before {
    content: "";
    display: inline-block;
    vertical-align: middle;
    padding-top: 100%;
    height: 0;
  }
  & > span {
    display: inline-block;
    vertical-align: middle;
  }
}
.noColleage {
  @include change_size($font_size_normal);
  color: rgb(186, 186, 186);
  background-color: #fff;
  padding: 30px;
  border-bottom: 1px dashed #ddd;
}

.header01Parent::-webkit-scrollbar {
  display: none;
}
.header01Parent {
  // padding-right: 6px;
  overflow: scroll;
  overflow-x: hidden;
  // &:hover {
  //   padding-right: 0px;
  //   &::-webkit-scrollbar {
  //     width: 6px;
  //     display: initial;
  //   }
  //   &::-webkit-scrollbar-thumb {
  //     background: #bec5ca;
  //     border-radius: 10px;
  //   }
  // }
}
</style>
